import React from "react";
import { Card, Table, Row } from "react-bootstrap";
import { useState, useEffect } from "react";
import { getVoucherGroups } from "./api/VoucherGroupApi";
import { useHistory } from "react-router-dom";
import Dollars from "../../common/typeFormatting/Dollars";
import IntegerFmt from "../../common/typeFormatting/IntegerFmt";


export default function VoucherGroupTotals() {
    let history = useHistory();

    const [voucherGroups, setVoucherGroups] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchData() {
            try {
                const groups = await getVoucherGroups();
                groups.sort((a,b) => new Date(b.issueDate) - new Date(a.issueDate));
                setVoucherGroups(groups);
                setLoading(false);
            }
            catch (error) {
                setLoading(false);
            }
        }

        fetchData();
    }, []);

    const groupSelected = (groupId) => {
        history.push(`/travel/vouchergroups/${groupId}`);
    }

    return (
        <div>
            <Card style={{marginTop: 25}}>
                <Card.Body>
                    <Card.Title>Allowance Groups</Card.Title>
                    <Row>
                        {!loading ? 
                            <Table hover responsive style={{fontSize: 12, overflowY: "auto"}} >
                                <thead style={{position: "sticky", top: 0}}>
                                    <tr>
                                        <th>Group Name</th>
                                        <th className="text-center">Total Issued</th>
                                        <th className="text-center">Initial Amount</th>
                                        <th className="text-center">Current Balance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {voucherGroups.length > 0 ? 
                                        voucherGroups.map(group => (
                                            <tr key={group.voucherGroupId} 
                                                onClick={() => groupSelected(group.voucherGroupId)} 
                                                className={'table-row'}>
                                                <td>{group.groupName}</td>
                                                <td className="text-center">
                                                    <IntegerFmt>{group.totalVouchers}</IntegerFmt>
                                                </td>
                                                <td className="text-center">
                                                    <Dollars>{group.initialAmount}</Dollars>
                                                </td>
                                                <td className="text-center">
                                                    <Dollars>{group.currentBalance}</Dollars>
                                                </td>
                                            </tr>
                                        )) : <tr><td>No Groups found.</td></tr>
                                    }                                           
                                </tbody>
                            </Table>
                            : <div>Loading...</div>
                        }                    
                    </Row>                
                </Card.Body>
            </Card>                 
        </div>        
    );
}
